<!--
 * @Author: 仙道
 * @Date: 2022-08-13 19:00:46
 * @LastEditTime: 2022-08-13 23:12:29
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/maintenance/overhaul/YwDailyOverhaulTaskListForPerson.vue
-->

<template>
  <a-card :bordered="false">
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->

    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <span slot="statusSlot" slot-scope="taskStatus">
          <span v-if="taskStatus== '-1'">
            <a-tag color="#108ee9">编辑中</a-tag>
          </span>
          <span v-else-if="taskStatus== '0'">
            <a-tag color="#faad14">已发布</a-tag>
          </span>
          <span v-else>
            <a-tag color="#52c41a">已完成</a-tag>
          </span>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if="record.taskStatus === '-1'">编辑</a>
          <a-divider type="vertical" v-if="record.taskStatus === '-1'" />
          <a @click="handlePublish(record)" v-if="record.taskStatus === '-1'">发布</a>
          <a @click="handleExucute(record)" v-if="record.taskStatus === '0'">执行</a>
          <a @click="handleRecord(record)" v-if="record.taskStatus === '1'">查看</a>
        </span>
      </a-table>
    </div>

    <yw-daily-overhaul-task-modal @ok="modalFormOk" ref="modalForm" />
    <yw-daily-overhaul-task-execute-modal @ok="modalFormOk" ref="executeForm" />
  </a-card>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import YwDailyOverhaulTaskModal from './modules/YwDailyOverhaulTaskModal'
  import YwDailyOverhaulTaskExecuteModal from './modules/YwDailyOverhaulTaskExecuteModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';

  export default {
    name: "YwDailyOverhaulTaskList",
    mixins: [JeecgListMixin],
    components: {
      YwDailyOverhaulTaskModal,
      YwDailyOverhaulTaskExecuteModal
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        description: '日常检修任务管理页面',
        // 查询条件
        queryParam: {
          manager: '',
          taskDate: [],
          taskStatus: '',
        },
        taskStatusOptions: [
          {
            label: "编制中",
            value: "-1"
          }, {
            label: "已发布",
            value: "0"
          }, {
            label: "已完成",
            value: "1"
          }],
        // 表头
        columns: [


          {
            title: '任务日期',
            align: "center",
            dataIndex: 'taskDate',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '负责人',
            align: "center",
            dataIndex: 'manager_dictText'
          },
          {
            title: '内部执行人员',
            align: "center",
            dataIndex: 'internalExecutor_dictText'
          },
          {
            title: '外聘执行人员',
            align: "center",
            dataIndex: 'externalExecutor'
          },
          {
            title: '任务状态',
            align: "center",
            dataIndex: 'taskStatus',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '完成时间',
            align: "center",
            dataIndex: 'finishTime'
          },
          {
            title: '实际完成人',
            align: "center",
            dataIndex: 'finishPerson'
          },
          {
            title: '发布人',
            align: "center",
            dataIndex: 'createBy'
          },
          {
            title: '发布日期',
            align: "center",
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/maintenance/overhaul/list",
          delete: "/maintenance/overhaul/delete",
          deleteBatch: "/maintenance/overhaul/deleteBatch",
          exportXlsUrl: "/maintenance/overhaul/exportXls",
          edit: "/maintenance/overhaul/edit",
          editMain: "/maintenance/overhaul/editMain",
        },
        dictOptions: {},
        superFieldList: [],
        queryParam: {},
        disableMixinCreated: true,
      }
    },
    created () {
      this.getSuperFieldList();
      this.queryParam = { ...this.query }
      this.loadData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      handleRecord (record) {
        this.$refs.executeForm.edit(record)
        this.$refs.executeForm.title = '报告'
        this.$refs.executeForm.disableSubmit = true
      },
      handleExucute (record) {
        this.$refs.executeForm.edit(record)
        this.$refs.executeForm.title = '任务执行'
        this.$refs.executeForm.disableSubmit = false
      },
      handlePublish (record) {
        httpAction(this.url.editMain, Object.assign(record, { taskStatus: '0' }), 'put').then((res) => {
          if (res.success) {
            this.modalFormOk();
          }
        })
      },
      getQueryParams () {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        delete param.taskDate; // 时间参数不传递后台
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      onDateChange: function (value, dateString) {
        this.queryParam.taskDate_begin = dateString[0];
        this.queryParam.taskDate_end = dateString[1];
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'orderNumber', text: '单号', dictCode: '' })
        fieldList.push({ type: 'date', value: 'taskDate', text: '任务日期' })
        fieldList.push({ type: 'sel_user', value: 'manager', text: '负责人' })
        fieldList.push({ type: 'sel_user', value: 'internalExecutor', text: '内部执行人员' })
        fieldList.push({ type: 'string', value: 'externalExecutor', text: '外聘执行人员', dictCode: '' })
        fieldList.push({ type: 'switch', value: 'taskStatus', text: '任务状态' })
        fieldList.push({ type: 'datetime', value: 'finishTime', text: '完成时间' })
        fieldList.push({ type: 'string', value: 'finishPerson', text: '实际完成人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'createBy', text: '发布人', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'createTime', text: '发布日期' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>